<!--
  2021-09-29 C007 实现新的Landing模板
-->
<template>
  <div style="overflow-y: scroll">
<!--    <img :src="download" class="downloader" @click="downloadApp"/>-->
    <img
      src="../../assets/images/landing/landing2_05.webp"
      style="width: 100%; display: block; padding: 0 0 0 0"
    />
    <div class="btnBox">
      <img @click="downloadApp" src="../../assets/images/landing/landing2_05_downloadBtn.webp" alt="" class="downloadBtn">
      <img @click="signUp" src="../../assets/images/landing/landing2_05_signUpBtn.webp" alt="" class="signUpBtn">
    </div>
    <div class="btnBox2">
      <img @click="downloadApp" src="../../assets/images/landing/landing2_05_downloadBtn.webp" alt="" class="downloadBtn">
      <img @click="signUp" src="../../assets/images/landing/landing2_05_signUpBtn.webp" alt="" class="signUpBtn">
    </div>
  </div>
</template>

<script>
import download from '@/assets/images/landing/header.png'
import {LogUtils, adListener} from '@/utils'
export default {
  name: 'Template2',
  data () {
    return {
      download
    }
  },
  mounted () {
    adListener('PageViewLanding')
    this.downloadApp()
  },
  methods: {
    downloadApp () {
      LogUtils.downloadApp('ClickTopDown')
    },
    signUp () {
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="less" scoped>
#app {
  #viewContainer {
    padding-bottom: 0px;

    .downloader{
      opacity: 0.9;
      position: fixed;
      height: 76px;
      top: 0;
      left: 0;
      width: 100vw;
      z-index: 1;
    }
    .btnBox{
      display: flex;
      flex-direction: column;
      gap: 3vw;
      position: absolute;
      top: 193vw;
      left: 13vw;
      .downloadBtn{
        width: 75vw;  /* 调整为原尺寸的 ~65% */
        height: calc(70vw * 0.173vw);  /* ≈12.11vw */
      }
      .signUpBtn{
        width: 75vw;  /* 调整为原尺寸的 ~65% */
        height: calc(70vw * 0.173vw);  /* ≈12.11vw */
      }
    }
    .btnBox2{
      display: flex;
      flex-direction: column;
      gap: 3vw;
      position: absolute;
      top: 465vw;
      left: 13vw;
      .downloadBtn{
        width: 75vw;  /* 调整为原尺寸的 ~65% */
        height: calc(70vw * 0.173vw);  /* ≈12.11vw */
      }
      .signUpBtn{
        width: 75vw;  /* 调整为原尺寸的 ~65% */
        height: calc(70vw * 0.173vw);  /* ≈12.11vw */
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Landing/template3.vue